import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import {EmptyRecord} from "../../utils/PageUtility";
import RecordPagination  from "../../utils/RecordsPagination";
import moment from "moment";


import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    tableStyle: {
        padding: 0
    },
    tableHeader: {
        color: "#04137b",
    }
};

const SettingTableStructure = ({classes, pageSize, currentPage, records, filterUsers, user, handleEdit, filterServiceType}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="regional">
            <TableRow>
                <TableCell className={classes.tableHeader} padding="none">S/N</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Old PSC Charge</TableCell>
                <TableCell className={classes.tableHeader} padding="none">New PSC Charge</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Currency</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Service Type</TableCell>
                <TableCell className={classes.tableHeader} padding="none">Start Date</TableCell>
                <TableCell className={classes.tableHeader}>Processed By</TableCell>
                <TableCell className={classes.tableHeader}>Status</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records && records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell padding="none" component="th">
                            {currentPage === 1 ? key + 1 : (pageSize * currentPage) + key + 1}
                        </TableCell>
                        <TableCell padding="none" component="th">
                            &#36; {appHelpers.numberWithCommas(item.OldCharges)}
                        </TableCell>
                        <TableCell padding="none" component="th">
                            &#36; {appHelpers.numberWithCommas(item.NewCharges)}
                        </TableCell>
                        <TableCell padding="none" component="th">{item.Currency}</TableCell>
                        <TableCell padding="none" component="th">{filterServiceType(item.ServiceType)}</TableCell>
                        <TableCell padding="none" component="th">{moment(item.StartDate).format("YYYY-MM-DD")}</TableCell>
                        <TableCell padding="none" component="th">
                            {filterUsers(item.ApprovedBy)}
                        </TableCell>
                        <TableCell padding="none" component="th">
                            {item.IsApproved === true && <span style={{color:"#66bb6a"}}>Approved</span>}
                            {item.IsApproved === false &&<span style={{color:"#dd2735"}}> Declined</span>}
                            {item.IsApproved === null && "Pending"}
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class ApprovedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            flight: false
        };
    }

    handleClickOpen = (flight) => {
        this.setState({ open: true });
        this.setState({flight});
        this.props.fetchFlightPassengers(flight.Id);
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { classes, handleEdit, searchError, filterUsers, user, records, fetchRecords, totalCounts, pageSize, currentPage, filterServiceType } = this.props;
        if(totalCounts === 0)
            return (<EmptyRecord message={'No Airline PSC Charge yet!'}/>);
        if(searchError)
            return (<EmptyRecord message={searchError}/>);
        return (
            <div>
                <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                    <RecordPagination fetchMore={fetchRecords} totalCount={totalCounts} pageSize={pageSize} currentPage={currentPage} target={<SettingTableStructure pageSize = {pageSize} currentPage = {currentPage} records={records} classes={classes} filterUsers={filterUsers} handleEdit={handleEdit} filterServiceType={filterServiceType} user={user} />}/>
                </div>
            </div>
        );
    }
}

export default withMobileDialog()(withStyles(styles)(ApprovedTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/PscSettings/approvedTable.js